import client from './client'
import { AxiosPromise } from 'axios'

export type UserReportPayload = {
  prescription?: string | null
  report_data: {
    issue_detail: {
      target_item: string
      correct_value: string
      desired_result: string
      rececom_result: string
      web_app_result: string
    }
    prescription_source: {
      source_type: string
      has_qr: boolean
      qr_displayed?: boolean | null
    }
    priority_info: {
      used_manual_input: boolean
      frequency: string
      daily_count: number
    }
  }
}

export const postUserReport = (data: UserReportPayload): AxiosPromise => {
  return client.post('api/user-reports/', data)
}
